<template>
  <teleport to="#modals">
    <div
      class="fixed inset-0 z-50 cursor-default overflow-y-auto"
      :class="{ 'w-full bg-white': isMobile }"
      data-cy="modal"
    >
      <div
        class="flex min-h-screen text-center"
        :class="{ 'items-center justify-center px-4 pt-4': !isMobile }"
      >
        <div v-if="!isMobile" class="fixed inset-0 transition-opacity">
          <div class="absolute inset-0 bg-black opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span v-if="!isMobile" class="hidden sm:inline-block sm:h-screen sm:align-middle">
          &#8203;
        </span>
        <div
          class="modal-base inline-block transform rounded-md bg-white text-left align-middle transition-all sm:my-8"
          :class="mainContentAreaWidth"
        >
          <div
            v-if="!isMobile"
            class="absolute -top-1 -right-5 z-50 -mr-10 cursor-pointer sm:-mr-15"
            data-cy="modal-close-btn"
          >
            <icon-close class="text-black/25" @click="$emit('close')" />
          </div>
          <div class="rounded-md bg-white sm:w-full" :class="{ 'h-[90%]': isMobile }">
            <div
              class="flex-column items-start border-gray-200 p-2 sm:p-6"
              :class="{ 'border-b': titleBorder }"
            >
              <div
                class="flex items-baseline space-x-5"
                :class="{ 'w-full justify-between': isMobile }"
              >
                <h1
                  v-if="title"
                  id="modal-headline"
                  class="text-xl font-semibold whitespace-pre-wrap text-heading"
                  :class="{ 'p-2': isMobile }"
                >
                  {{ title }}
                </h1>
                <icon-close v-if="isMobile" class="cursor-pointer" @click="$emit('close')" />
              </div>
            </div>
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>
<script setup lang="ts">
import { onBeforeUnmount, onMounted, computed } from "vue";
import { useResponsive } from "@/composables/common";
import IconClose from "@/components/icons/IconClose.vue";

const {
  title = "",
  size = "regular",
  titleBorder = false,
} = defineProps<{
  title?: string;
  size?: "xl" | "large" | "regular" | "small";
  titleBorder?: boolean;
}>();

const emit = defineEmits(["close"]);

const { isMobile } = useResponsive();

const mainContentAreaWidth = computed(() => {
  if (isMobile.value) {
    return "w-full";
  }
  return {
    xl: "w-11/12",
    large: "w-7/12",
    regular: "w-5/12",
    small: "w-125",
  }[size];
});

const escapeCallback = (keyboardEvent: KeyboardEvent) => {
  if (keyboardEvent.code === "Escape") {
    emit("close");
  }
};

onMounted(() => {
  document.addEventListener("keydown", escapeCallback);
});

onBeforeUnmount(() => {
  document.removeEventListener("keydown", escapeCallback);
});
</script>
